"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearFlagOvr = exports.setFlagOvr = void 0;
var setFlagOvr = function (window, flagName, value) {
    window.sessionStorage.setItem("feature-override-".concat(flagName), JSON.stringify(value));
};
exports.setFlagOvr = setFlagOvr;
var clearFlagOvr = function (window, flagName) {
    window.sessionStorage.removeItem("feature-override-".concat(flagName));
};
exports.clearFlagOvr = clearFlagOvr;
